import React from 'react';
import { Link } from 'react-router-dom';

import ContactIcons from '../Contact/ContactIcons';
import { useLanguage } from '../LanguageContext';
import useLanguageRouting from '../useLanguageRouting';

const { PUBLIC_URL } = process.env; // set automatically from package.json:homepage

const SideBar = () => {
  const { lang, t } = useLanguage();
  const { localize } = useLanguageRouting();

  return (
  <section id="sidebar">
    <section id="intro">
      <Link to={localize('/')} className="logo">
        <img src={`${PUBLIC_URL}/images/me.jpg`} alt="" />
      </Link>
      <header>
        <h2>Sara Buczna</h2>
        <p style={{ marginBottom: '0.25em' }}><a href="mailto:sarabuczna@gmail.com">sarabuczna@gmail.com</a></p>
      </header>
    </section>

    <section className="blurb">
      <h2>{t.sidebar.about}</h2>
      {lang === 'pl' ? (
        <p>
          Cześć, jestem <strong>Sara</strong> — dietetyczka w <i>Warszawie</i> i studentka
          studiów magisterskich na <strong>Warszawskim Uniwersytecie Medycznym</strong>.
          Bo <strong><i>&bdquo;jesteś tym, co jesz&rdquo;</i></strong>, pomagam ludziom
          budować zdrowsze nawyki, posiłek po posiłku.
        </p>
      ) : (
        <p>
          Hi, I&apos;m <strong>Sara</strong> — Dietitian in <i>Warsaw</i> and MSc student
          at the <strong>Medical University of Warsaw</strong>. Because
          <strong><i>&quot;You are what you eat&quot;</i></strong>,
          I help people build healthier habits, one meal at a time.
        </p>
      )}
    </section>

    <section id="footer">
      <ContactIcons />
      <p className="copyright" suppressHydrationWarning>&copy; {new Date().getFullYear()} Sara Buczna</p>
    </section>
  </section>
  );
};

export default SideBar;
